import { jsx as _jsx } from "react/jsx-runtime";
import { Primary as DSPrimary } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./primary.module.css";
export const Primary = ({ className , children , ...rest })=>/*#__PURE__*/ _jsx(DSPrimary, {
        classNames: {
            button: cx(styles.root, className)
        },
        ...rest,
        children: children
    });
